import React, { memo, useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { debounce } from "lodash";
import QuickView from "../QuickView/QuickView";
import {
	SaleCampaignHeader,
	EmptyCampaignProductContent,
	PageWrapper,
	SaleCampaignItemWrapper,
} from "./SaleCampaign.style";
import SaleCampaignItem from "../../components/SalePromotionCampaign/SaleCampaignItem";
import { LocalOffer } from "@material-ui/icons";
import reactStringReplace from "react-string-replace";
import t from "../../i18n/translate";

function SaleCampaign({
	props,
	saleCampaign,
	cartType,
	type,
	color,
	limit,
	loader,
}) {
	const history = useHistory();

	const [show, setShow] = useState(false);
	const [load, setLoad] = useState(false);

	const onHide = () => setShow(false);

	const handleQuickViewModal = (modalProps, index) => {
		props.ProductModalData(modalProps);

		setShow(true);
		// trackClick(modalProps, index);
		// trackDetails(modalProps, index);
	};

	const isInViewport = useCallback(
		debounce(() => {
			const wrappedElement = document.querySelector(".product-campaign-list");
			if (
				wrappedElement &&
				wrappedElement.getBoundingClientRect().bottom <= window.outerHeight
			) {
				if (props?.total_pages > props?.page) {
					if (document.getElementById("showMore")) {
						setLoad(true);
						document.getElementById("showMore").click();
					}
				} else {
					setLoad(false);
				}
			}
		}, 100),
		[props.page, props.products]
	);

	useEffect(() => {
		document.addEventListener("scroll", isInViewport);

		return () => {
			document.removeEventListener("scroll", isInViewport);
		};
	}, []);

	useEffect(() => {
		if (!saleCampaign?.name_ref_id) return;
		props.getAllProductsSaleCampaign({
			campaign_id: saleCampaign?.campaign_id,
			limit: limit,
			page: props?.page,
		});
	}, [props.page]);

	const handleClickShowMore = () => {
		props.changeCampaignProductPage({ page: props?.page + 1 });
		setLoad(false);
	};

	const totalItemsCount = reactStringReplace(
		t("promotion_campaign_total_items_count_label", false),
		/({path})/g,
		() => props?.total_items
	);

	return (
		<PageWrapper>
			<Card
				className="p-0"
				style={{ width: "100%", height: "100%", border: "none" }}
			>
				<Card.Header className="p-0 border-0 bg-white">
					<SaleCampaignHeader>
						<p className="campaign-title">{saleCampaign?.name}</p>
						<LocalOffer style={{ color }} />
						<span className="total-items-count">{totalItemsCount}</span>
					</SaleCampaignHeader>
				</Card.Header>
				<Card.Body className="p-0">
					{props.products?.length >= 1 ? (
						<SaleCampaignItemWrapper className="product-campaign-list">
							{props.products?.map((item, index) => (
								<SaleCampaignItem
									item={item}
									key={item.item_id}
									cartType={cartType}
									type={type}
									itemId={item.item_id}
									sku={item.product_code}
									name={item.name}
									itemRefId={item.item_ref_id}
									imgUrl={item.default_image_url}
									countryCode={item.country?.code ?? null}
									price={item.store_items_price_type.mrp}
									salePrice={item.store_items_price_type.price}
									promo={item.promo}
									promoPrice={item.promo === 1 ? item.promo_price : null}
									promoStartDate={item.promo === 1 ? item.promo_start_date : null}
									promoEndDate={item.promo === 1 ? item.promo_end_date : null}
									outOfStock={!item.store_items_price_type.available_quantity}
									isSameDay={item.same_day ?? 0}
									isAvailableTomorrow={item.available_tommorrow ?? 0}
									isShopOpen={item.is_shop_open ?? false}
									weight={
										item.store_items_price_type.name !== ""
											? item.store_items_price_type.name
											: item.store_items_price_type.weight +
											  " " +
											  item.store_items_price_type.weight_unit
									}
									brandId={
										item.brand_id === 0 || item.brand_id === null ? 0 : item.brand_id
									}
									brands={props.brands}
									color={color}
									loader={loader}
									onClick={() => {
										if (cartType === "express") {
											handleQuickViewModal(item, index);
										} else {
											history.push(`/product/${item.item_ref_id}`);
											window.scrollTo(0, 0);
										}
									}}
								/>
							))}
							<div className="w-100 rounded rounded-2">
								<Button
									id={"showMore"}
									onClick={handleClickShowMore}
									size="small"
									className={`${
										load || props?.page >= props?.total_pages
											? "d-none"
											: "d-flex w-100 h-100"
									}`}
									variant="outline-light"
								>
									{loader("relative")}
								</Button>
							</div>
						</SaleCampaignItemWrapper>
					) : props.loading ? (
						loader()
					) : (
						<EmptyCampaignProductContent>
							<p className="empty-campaign-title">
								{t("promotion_campaign_no_products_title")}:(
							</p>
						</EmptyCampaignProductContent>
					)}
				</Card.Body>
			</Card>

			{/* QuickView */}
			{show && (
				<QuickView
					show={show}
					onHide={onHide}
					props={props}
					// deviceType={deviceType}
					// onCartClick={() => {
					// 	handleJoin();
					// }}
				/>
			)}
		</PageWrapper>
	);
}

export default memo(SaleCampaign);
